import React from 'react';
import { Link } from 'react-router-dom';
import Shop1 from '../../images/product-cetegory/1.png'
import Shop2 from '../../images/product-cetegory/2.png'
import Shop3 from '../../images/product-cetegory/3.png'


const ProductCetegorySection = (props) => {
    return (
        <section className={"" + props.hclass}>
            <div className="row g-0">
                <div className="col col-lg-4 col-md-6 col-12 fade_bottom">
                    <div className="product-card">
                        <h2><Link to="/shop">Spring Collection</Link></h2>
                        <span><Link to="/shop">Shop Now</Link></span>
                        <img src={Shop1} alt="" />
                    </div>
                </div>
                <div className="col col-lg-4 col-md-6 col-12 fade_bottom">
                    <div className="product-card">
                        <h2><Link to="/shop">Special Offer</Link></h2>
                        <span><Link to="/shop">Shop Now</Link></span>
                        <img src={Shop2} alt="" />
                    </div>
                </div>
                <div className="col col-lg-4 col-md-6 col-12 fade_bottom">
                    <div className="product-card">
                        <h2><Link to="/shop">Delivered To You </Link></h2>
                        <span><Link to="/shop">Shop Now</Link></span>
                        <img src={Shop3} alt="" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProductCetegorySection;